module.exports = __webpack_public_path__ + "img/disabledToggle.20ccb70d.svg";